// BUILD-046 J1a: the small drawings of a task's Customer / Job. The rules (what shows, which words) are in jobDisplayModel.ts.
//   JobText  : the job name, with a quiet note after it when the name is the last known one, the job was not found, or it is archived.
//   jobPart  : the job as the FIRST part of the Comfortable quiet second line (null when the row has no job or the density is Compact: Compact has the column).
import type { ReactNode } from 'react';
import type { Density } from './densityStore';
import { jobInSecondLine, jobLineOf, jobOf } from './jobDisplayModel';
import type { JobShown } from './jobDisplayModel';
import { TruncatedText } from './TruncatedText';

export function JobText({ job, truncate = false }: { job: JobShown; truncate?: boolean }) {
  const line = jobLineOf(job);
  const body = (
    <>
      <span className="font-medium text-gray-800">{line.label}</span>
      {line.note !== null && <span className="text-gray-500"> ({line.note})</span>}
    </>
  );
  // Where the column cuts the name short (Compact), the full name is on hover AND on keyboard focus (TruncatedText); elsewhere it is plain text with the same hover text as before.
  if (truncate) return <TruncatedText text={line.title} block testId="job-text">{body}</TruncatedText>;
  return (
    <span title={line.title} data-testid="job-text">
      {body}
    </span>
  );
}

/** The job for the quiet second line of a Comfortable row; null when there is none or in Compact. */
export function jobPart(task: unknown, density: Density): ReactNode {
  if (!jobInSecondLine(density)) return null;
  const job = jobOf(task);
  return job === null ? null : <JobText key="job" job={job} />;
}
